<template>
  <v-stepper-content step="3" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">Corporate Office Information</div>
          </v-col>

          <v-col cols="12" class="mt-8">
            <v-text-field
              outlined
              label="*Primary Contact"
              class="rounded-lg"
              hide-details
              v-model="primaryContactName"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="*Address Line 1"
              class="rounded-lg"
              hide-details
              v-model="address1"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Address Line 2"
              class="rounded-lg"
              hide-details
              v-model="address2"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="*City"
              class="rounded-lg"
              hide-details
              v-model="city"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-combobox
              v-model="state"
              :items="states"
              item-value="Abbr"
              item-text="Full"
              outlined
              label="*State"
              class="rounded-lg"
              hide-details
              :return-object="false"
            ></v-combobox>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="*Postal Code"
              class="rounded-lg"
              hide-details
              v-model="postalCode"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="*Telephone Number"
              class="rounded-lg"
              hide-details
              v-model="phone"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Fax Number"
              class="rounded-lg"
              hide-details
              v-model="fax"
            ></v-text-field>
          </v-col>

          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import States from '@/Data/States';
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'STepThree',
  components: {
    BtnContinue,
  },
  data: () => ({
    select2: null,
    states: States,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    select: {
      get() {
        return this.select2;
      },
      set(value) {
        this.select2 = value.Abbr;
      },
    },
    contactType() {
      return this.$store.state.prospectPacket.companyInfo.primaryContactType;
    },
    contact: {
      get() {
        return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactType);
      },
      set(value) {
        this.$store.state.commit('updateContactObject', value);
      },
    },
    primaryContactName: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.name;
      },
      set(value) {
        this.contact.name = value;
      },
    },
    address1: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.address1;
      },
      set(value) {
        this.contact.address1 = value;
      },
    },
    address2: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.address2;
      },
      set(value) {
        this.contact.address2 = value;
      },
    },
    city: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.city;
      },
      set(value) {
        this.contact.city = value;
      },
    },
    state: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.state;
      },
      set(value) {
        this.contact.state = value;
      },
    },
    postalCode: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.zip;
      },
      set(value) {
        this.contact.zip = value;
      },
    },
    phone: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.phone;
      },
      set(value) {
        this.contact.phone = value;
      },
    },
    fax: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.fax;
      },
      set(value) {
        this.contact.fax = value.length > 16 ? value.slice(0, 16) : value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
